import { jsx } from 'react/jsx-runtime';

const FakePlayer = () => {
  return jsx("video", {});
};

export { FakePlayer as default };
